import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { PortalService } from '../../../core/services/portal.service';
import { Portal } from '../../../core/models/portal.model';
import { Select } from '@ngxs/store';
import { BotState } from '../../../core/store/bot/bot.state';
import { Observable, Subject } from 'rxjs';
import { Bot } from '../../../core/models/bot.model';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'brn-nav-bot',
  templateUrl: './nav-bot.component.html',
  styleUrls: ['./nav-bot.component.scss'],
})
export class NavBotComponent implements OnInit, OnDestroy {
  @Select(BotState.getBot) bot$!: Observable<Bot>;
  bot: Bot = new Bot();
  portalSettings: Portal;

  private unsubscribe$: Subject<any> = new Subject();

  constructor(public location: Location) {
    this.portalSettings = PortalService.Settings;
  }

  ngOnInit(): void {
    this.bot$.pipe(takeUntil(this.unsubscribe$)).subscribe((bot) => {
      if (bot) {
        this.bot = bot;
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
